export const en = {
    campaign_context_enable_cpc_hold: 'Keep average CPC below average Search CPC',
    campaign_context_limit:
        'Keep expenditure within {oldLimitPercent} {newLimitPercent} of the total campaign expenditure',
    campaign_context_price_coef: 'Maximum CPC {oldPriceCoef} {newPriceCoef} from the Search CPC'
};
